import { Component } from '@angular/core';

@Component({
  selector: 'app-frame',
  standalone: false,
  templateUrl: './frame.component.html',
  styleUrl: './frame.component.scss'
})
export class FrameComponent {

}
